import {
  FormaDistribuicaoArrecadacaoEnum,
  TipoArrecadacaoEnum,
} from "features/arrecadacoes/enums";
import { ArrecadacaoForm } from "features/arrecadacoes/typings/form";
import { FormArrecadacaoChildrenFormProps } from "../components/FormArrecadacao";
import FormCriarFundoFracao from "../components/FormCriarFundoFracao";
import FormGeral from "../components/FormGeral";
import FormRateio from "../components/FormRateio";
import FormUnidades from "../components/FormUnidades";
import FormValor from "../components/FormValor";
import FormValorIndividual from "./../components/FormValorIndividual";

interface FormArrecadacaoStep {
  title: string;
  component?: React.FC<FormArrecadacaoChildrenFormProps> | React.FC<any>;
  extraProps?: Record<string, any>;
}

export default function getSteps(
  form: ArrecadacaoForm,
  {
    month,
    year,
    idArrecadacao,
  }: { month: string; year: string; idArrecadacao?: string }
): FormArrecadacaoStep[] {
  const steps: FormArrecadacaoStep[] = [
    {
      title: "Geral",
      component: FormGeral,
      extraProps: {
        month,
        year,
        idArrecadacao,
      },
    },
    {
      title: "Unidades",
      component: FormUnidades,
    },
  ];

  if (
    form.formaDistribuicaoArrecadacaoId !==
    FormaDistribuicaoArrecadacaoEnum.Consumo
  ) {
    steps.push({ title: "Valor", component: FormValor });
  }
  // else if (
  //   ![
  //     TipoArrecadacaoEnum.ValorMetrosUnidade,
  //     TipoArrecadacaoEnum.ValorIgualTodasUnidades,
  //   ].includes(form.tipoArrecadacaoId!)
  // ) {
  //   steps.push({ title: "Criar fundo", component: FormCriarFundoFracao });
  // }

  // if (
  //   (![
  //     TipoArrecadacaoEnum.ValorMetrosUnidade,
  //     TipoArrecadacaoEnum.ValorIgualTodasUnidades,
  //   ].includes(form.tipoArrecadacaoId) &&
  //     form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorIgualTodasUnidades) ||
  //   form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorMetrosUnidade
  // ) {
  //   steps.push({
  //     title: "Criar fundo",
  //     component: FormCriarFundoFracao,
  //   });
  // }

  if (form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorObtidoRateioDespesa) {
    steps.push(
      {
        title: "Rateio",
        component: FormRateio,
        extraProps: {
          month,
          year,
        },
      },
      {
        title: "Fração",
        component: FormCriarFundoFracao,
        extraProps: {
          type: "FRACAO",
        },
      }
    );
  }

  if (
    form.tipoArrecadacaoId ===
      TipoArrecadacaoEnum.ValorObtidoPrevisaoOrcamentaria ||
    form.tipoArrecadacaoId === TipoArrecadacaoEnum.DespesaMesAnterior ||
    form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorTotalRateado
  ) {
    steps.push({
      title: "Fração",
      component: FormCriarFundoFracao,
      extraProps: {
        type: "FRACAO",
        showArrecadar: true,
      },
    });
  }

  if (form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorPorIndexador) {
    steps.push({
      title: "Peso",
      component: FormCriarFundoFracao,
      extraProps: {
        type: "PESO",
      },
    });
  }

  if (
    form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorDiferenteCadaUnidade &&
    form.formaDistribuicaoArrecadacaoId !==
      FormaDistribuicaoArrecadacaoEnum.UnicaUnidade
  ) {
    steps.push({
      title: "Valor manual",
      component: FormValorIndividual,
      extraProps: {
        idArrecadacao,
      },
    });
  }

  return steps;
}
